
import { Injectable } from '@angular/core';
import { ItemDetails } from '../_models/item/item-details.model';
import { ItemRequest } from '../_models/item/item-request.model';

import { RequestHelperProvider } from '../../app/_services/request-helper';

import utils from './../utils';
import { ItemBalance } from '../_models/item/item-balance.model';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { StorageKeys } from '../_constants';
import { StorageServiceProvider } from './storage.service';
import { ItemSearchType } from '../enums';

import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ItemServiceProvider {

  constructor(private helper: RequestHelperProvider, private http: HttpClient, private storage: StorageServiceProvider, private authenticationService: AuthenticationService) {
  }

  public searchItem(request: ItemRequest, callback, failedcallback) {
    //this.syncItemsLive(request, callback, failedcallback);
    let numberOfItemsInSearchResult = utils.getNumberOfItemsInSearchResult();
    let items;
    this.syncItemsLiveRelational(request, numberOfItemsInSearchResult).then(data => {
      if (data.length == numberOfItemsInSearchResult) {
        callback(data);
      }
      else {
        items = data;
        this.syncItemsLiveRelational(request, numberOfItemsInSearchResult, 'contains').then(data1 => {
          items = items.concat(data1);

          //remove duplicate items
          items = items.filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.place === value.place && t.name === value.name
            )));

          //return number of item as per settings
          let returnItems = [];
          items.slice([0], [numberOfItemsInSearchResult]).map((item, i) => {
            returnItems.push(item);
          });

          callback(returnItems);
        }).catch(error => {
          if (items.length > 0)
            callback(items);
          else
            failedcallback(error);
        });
      }
    }).catch(error => {
      if (error.Code == 404) {
        this.syncItemsLiveRelational(request, numberOfItemsInSearchResult, 'contains').then(data1 => {
          callback(data1);
        }).catch(error => {
          if (error.Code == 404) {
            callback([]);
          }
        });
      } else
        failedcallback(error);
    });
  }
  public IsPriceOverrideAllowed(): Promise<any> {

    var response: any = {
      overrideWithoutWarning: false,
      overrideWithWarning: false,
      overrideRestricted: false
    };
    return new Promise((resolve, reject) => {
      this.GetPackageSetupToken("INV", "SO_PRICE_OUTSIDE_MINMAX").then((g) => {
        if (g != null && g[0].SetupValue == "Y") {

          response.overrideWithoutWarning = true;
          resolve(response);
        }
        else {

          let loginid = localStorage.getItem('loginUserId');
          let OVRMMtrue = false;
          this.authenticationService.getUserPermissions(loginid, (permissions) => {
            permissions.forEach(permission => {
              if (permission.SecurityOption == "OVRMM" && permission.Package == 'INV') {
                OVRMMtrue = true;
                if (parseInt(permission.SecurityLevel) > 0) {
                  response.overrideWithWarning = true;
                }
                else {
                  response.overrideRestricted = true;
                }
              }
              else {
                if (OVRMMtrue) {
                  response.overrideRestricted = false;
                } else {
                  response.overrideRestricted = true;
                }

              }

            });
            resolve(response);
          }, (e) => { reject(e) })
        }

      })
        .catch((err) => {
          reject(err);
        })
    });
  }
  public GetPackageSetupToken(packageCode, setupToken): Promise<any> {
    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;

      if (agentType == "SQL") {
        url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=<<PackageSetupToken.TenantID>> eq ? and <<PackageSetupToken.PackageCode>> eq ? and <<PackageSetupToken.SetupToken>> eq ? &param0=${dataSet.TenantID}&param1=${packageCode}&param2=${setupToken}`
      }
      else {
        url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=<<PackageSetupToken.PackageCode>> eq ? and <<PackageSetupToken.SetupToken>> eq ? &param0=${packageCode}&param1=${setupToken}`
      }
      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
        resolve(data);
      }, (error) => {
        reject(error.error);
      }, dataSet.TenantID, 'CrossTenantQuery|true')
    });
  }
  public getUserPermissionsRelational(packageCode, securityOption): Promise<any> {
    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;

      if (agentType == "SQL") {
        url = `/culturahub/RESTActivityWebService/agris.relational/UserMenuSecurityLevel?where=<<UserMenuSecurityLevel.TenantID>> eq ? and <<UserMenuSecurityLevel.Package>> eq ? and <<UserMenuSecurityLevel.SecurityOption>> eq ? &param0=${dataSet.TenantID}&param1=${packageCode}&param2=${securityOption}`
      }
      else {
        url = `/culturahub/RESTActivityWebService/agris.relational/UserMenuSecurityLevel?where=<<UserMenuSecurityLevel.Package>> eq ? and <<UserMenuSecurityLevel.SecurityOption>> eq ? &param0=${packageCode}&param1=${securityOption}`
      }
      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
        resolve(data);
      }, (error) => {
        reject(error.error);
      }, dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true` : ``}`)
    });
  }
  public syncItemsLive(request: ItemRequest, callback, failedcallback) {
    let location = utils.getLocation();
    let numberOfItemsInSearchResult = utils.getNumberOfItemsInSearchResult();
    let tenantID = this.storage.get(StorageKeys.DataSet).TenantID;
    let description = encodeURIComponent(request.name);
    let onHand = utils.getShowQuantityOfAllLocations();
    this.helper.PostServerCommand(
      `/culturahub/RESTCommandWebService/ExecuteServerCommand/ItemProcessor/GetItems?TenantID=${tenantID}&SelectedEntities=[InventoryItem:InventoryBarCodes]&InventoryLocation=${location}&ItemNumber=${request.id}&Description=${description}&ProductCategory=${request.categoryDescription}&TopN=${numberOfItemsInSearchResult}&Onhand=${onHand}`, null,
      (data) => {
        if (data) {
          let arr = [];
          //  arr = (data.Items.map(d => { let obj = d; delete obj._Entity; return obj }));
          arr = data;
          let itemList: ItemDetails[] = [];
          console.log(arr);
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].CreatedBy != null) {
              let itemBalance = new ItemBalance();
              itemBalance = JSON.parse(arr[i].CreatedBy)
              if (itemBalance.ItemNumber != null) {
                let resultvalue = new ItemDetails();
                if (onHand && arr[i].LastUpdatedBy) {
                  let allLocationOnHand = JSON.parse(arr[i].LastUpdatedBy);
                  itemBalance.OnHandQuantity = allLocationOnHand.OnHand ? allLocationOnHand.OnHand : 0;
                }
                resultvalue.itemId = arr[i].ItemNumber;
                resultvalue.id = arr[i].ItemNumber;
                resultvalue.itemDescription = arr[i].Description;
                resultvalue.name = arr[i].Description;
                resultvalue.uomschedule = arr[i].SalesUOMDefault;
                resultvalue.uom = arr[i].SalesUOMDefault;
                resultvalue.defaultSellingUom = arr[i].SalesUOMDefault;
                resultvalue.inactive = arr[i].Active;
                resultvalue.branch = arr[i].InventoryLocation;
                resultvalue.category = arr[i].ProductCategory;
                resultvalue.categoryDescription = arr[i].ProductCategoryDV;
                resultvalue.priceLevel1 = arr[i].SellingPrice1;
                resultvalue.priceLevel2 = arr[i].SellingPrice2;
                resultvalue.classCode = arr[i].ClassCode
                resultvalue.commodity = arr[i].Commodity
                resultvalue.costPercent = arr[i].CostPercent
                resultvalue.costProrationMethodDefault = arr[i].CostProrationMethodDefault
                resultvalue.createdBy = "";
                resultvalue.createdDate = arr[i].CreatedDate
                resultvalue.descriptionPartial1of3 = arr[i].DescriptionPartial1of3
                resultvalue.descriptionPartial2of3 = arr[i].DescriptionPartial2of3
                resultvalue.discountTableDefault = arr[i].DiscountTableDefault
                resultvalue.formulaBase = arr[i].FormulaBase
                resultvalue.inventoryItemRemarks = arr[i].InventoryItemRemarks
                resultvalue.inventoryLocation = arr[i].InventoryLocationDV
                resultvalue.inventoryMisc1Code = arr[i].InventoryMisc1Code
                resultvalue.inventoryMisc2Code = arr[i].InventoryMisc2Code
                resultvalue.inventoryMisc3Code = arr[i].InventoryMisc3Code
                resultvalue.inventoryMisc4Code = arr[i].InventoryMisc4Code
                resultvalue.inventoryMisc5Field = arr[i].InventoryMisc5Field
                resultvalue.inventoryMisc6Field = arr[i].InventoryMisc6Field
                resultvalue.inventoryMisc7Field = arr[i].InventoryMisc7Field
                resultvalue.itemOption = arr[i].ItemOption
                resultvalue.itemType = arr[i].ItemType
                resultvalue.lastPhysicalCountDate = arr[i].LastPhysicalCountDate
                resultvalue.lastProductionStage = arr[i].LastProductionStage
                resultvalue.lastUpdatedBy = arr[i].LastUpdatedBy
                resultvalue.lastUpdatedDate = arr[i].LastUpdatedDate
                resultvalue.maintainOperationalCost = arr[i].MaintainOperationalCost
                resultvalue.maximumPrice = arr[i].MaximumPrice
                resultvalue.minimumPrice = arr[i].MinimumPrice
                resultvalue.operationalCostDate = arr[i].OperationalCostDate
                resultvalue.packageUOM = arr[i].PackageUOM
                resultvalue.parentItemNumber = arr[i].ParentItemNumber
                resultvalue.productCategory = arr[i].ProductCategory
                resultvalue.purchaseOrderTolerance = arr[i].PurchaseOrderTolerance
                resultvalue.purchaseUOMDefault = arr[i].PurchaseUOMDefault
                resultvalue.restrictedProduct = arr[i].RestrictedProduct
                resultvalue.sqlID = arr[i].SQLID
                resultvalue.salesOrderTolerance = arr[i].SalesOrderTolerance
                resultvalue.standardRemark1 = arr[i].StandardRemark1;
                resultvalue.standardRemark2 = arr[i].StandardRemark2;
                resultvalue.standardRemark3 = arr[i].StandardRemark3;
                resultvalue.standardRemark4 = arr[i].StandardRemark4;
                resultvalue.standardRemark5 = arr[i].StandardRemark5;
                resultvalue.standardRemark6 = arr[i].StandardRemark6;
                resultvalue.standardRemark7 = arr[i].StandardRemark7;
                resultvalue.standardRemark8 = arr[i].StandardRemark8;
                resultvalue.standardRemark9 = arr[i].StandardRemark9;
                resultvalue.standardRemark10 = arr[i].StandardRemark10;
                resultvalue.stockingUOM = arr[i].StockingUOM;
                resultvalue.stockingUnitsPerPackage = arr[i].StockingUnitsPerPackage;
                resultvalue.taxTable1Default = arr[i].TaxTable1Default;
                resultvalue.taxTable2Default = arr[i].TaxTable2Default;
                resultvalue.taxTable3Default = arr[i].TaxTable3Default;
                resultvalue.tenantID = arr[i].TenantID;
                resultvalue.universalProductCode = arr[i].UniversalProductCode;
                resultvalue.useSubitems = arr[i].UseSubitems;
                resultvalue.varietyCode = arr[i].VarietyCode;
                resultvalue.weightPerStockingUOM = arr[i].WeightPerStockingUOM;
                resultvalue.whereStored = arr[i].WhereStored;
                resultvalue.inventoryBarCodes = arr[i].InventoryBarCodes;
                resultvalue.itemBalance = itemBalance;
                itemList.push(resultvalue);
              }
            }
          }
          callback(itemList);
        }
      }, (error) => {
        failedcallback(error)
      }
    )
  }
  public syncItemsLiveRelational(request: ItemRequest, numberOfItemsInSearchResult, descriptionSearchFilter: string = 'startsWith'): Promise<any> {
    return new Promise((resolve, reject) => {
      let location = utils.getLocation();
      let tenantID = this.storage.getTenantID();
      let description = encodeURIComponent(request.name);
      let onHand = utils.getShowQuantityOfAllLocations();
      let params = [];
      let agentType = localStorage.getItem('AgentType');
      let settings = this.storage.get(StorageKeys.Settings);
      let dataSet = this.storage.get(StorageKeys.DataSet);
      agentType == 'SQL' && tenantID ? params.push(`<<InventoryItem.TenantID>> eq '${tenantID}'`) : '';
      request.id ? params.push(`<<InventoryItem.ItemNumber>> contains '${request.id.trim()}'`) : '';
      request.name ? params.push(`<<InventoryItem.Description>> ${descriptionSearchFilter} '${request.name.trim()}'`) : '';
      request.categoryDescription ? params.push(`<<InventoryItem.ProductCategory>> contains '${request.categoryDescription.trim()}'`) : '';
      location ? params.push(`<<InventoryItem.InventoryLocation>> eq '${location}'  AND <<InventoryItem.Active>> eq 'Y'`) : '';
      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      let url = `/culturahub/RESTActivityWebService/agris.relational/InventoryItem?where=`;
      params.forEach((param, i) => {
        url = `${url}${(i > 0) ? ' and ' : ''}${param}`
      });
      let ORParams = [];
      request.itemBarCode ? params.push(`<<InventoryItem.InventoryBarCodes>> AND <<InventoryBarCodes.BarCode>> contains '${request.itemBarCode}'`) : '';
      ORParams.forEach((param, i) => {
        url = `${url}${(i > 0) ? ' OR ' : ''}${param}`
      });
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, '[InventoryItem:InventoryBarCodes]', (data) => {
        if (data) {
          let arr = [];
          //  arr = (data.Items.map(d => { let obj = d; delete obj._Entity; return obj }));
          arr = data;
          let itemList: ItemDetails[] = [];
          for (var i = 0; i < arr.length; i++) {

            // if (arr[i].CreatedBy != null && this.utilities.isValidJSON(arr[i].CreatedBy)) {
            //   let itemBalance = new ItemBalance();
            //   itemBalance = JSON.parse(arr[i].CreatedBy)
            //   if (itemBalance.ItemNumber != null) {
            let resultvalue = new ItemDetails();
            resultvalue.id = arr[i].ItemNumber;
            resultvalue.itemId = arr[i].ItemNumber;
            resultvalue.itemDescription = arr[i].Description;
            resultvalue.name = arr[i].Description;
            resultvalue.uomschedule = arr[i].SalesUOMDefault;
            resultvalue.uom = arr[i].SalesUOMDefault;
            resultvalue.defaultSellingUom = arr[i].SalesUOMDefault;
            resultvalue.inactive = arr[i].Active;
            resultvalue.branch = arr[i].InventoryLocation;
            resultvalue.category = arr[i].ProductCategory;
            resultvalue.categoryDescription = arr[i].ProductCategoryDV;
            resultvalue.price = arr[i].SellingPrice1;
            resultvalue.priceLevel1 = arr[i].SellingPrice1;
            resultvalue.priceLevel2 = arr[i].SellingPrice2;
            resultvalue.classCode = arr[i].ClassCode
            resultvalue.commodity = arr[i].Commodity
            resultvalue.costPercent = arr[i].CostPercent
            resultvalue.costProrationMethodDefault = arr[i].CostProrationMethodDefault
            resultvalue.createdBy = "";
            resultvalue.createdDate = arr[i].CreatedDate
            resultvalue.descriptionPartial1of3 = arr[i].DescriptionPartial1of3
            resultvalue.descriptionPartial2of3 = arr[i].DescriptionPartial2of3
            resultvalue.discountTableDefault = arr[i].DiscountTableDefault
            resultvalue.formulaBase = arr[i].FormulaBase
            resultvalue.inventoryItemRemarks = arr[i].InventoryItemRemarks
            resultvalue.inventoryLocation = arr[i].InventoryLocationDV
            resultvalue.location =arr[i].InventoryLocation
            resultvalue.inventoryMisc1Code = arr[i].InventoryMisc1Code
            resultvalue.inventoryMisc2Code = arr[i].InventoryMisc2Code
            resultvalue.inventoryMisc3Code = arr[i].InventoryMisc3Code
            resultvalue.inventoryMisc4Code = arr[i].InventoryMisc4Code
            resultvalue.inventoryMisc5Field = arr[i].InventoryMisc5Field
            resultvalue.inventoryMisc6Field = arr[i].InventoryMisc6Field
            resultvalue.inventoryMisc7Field = arr[i].InventoryMisc7Field
            resultvalue.itemOption = arr[i].ItemOption
            resultvalue.itemType = arr[i].ItemType
            resultvalue.lastPhysicalCountDate = arr[i].LastPhysicalCountDate
            resultvalue.lastProductionStage = arr[i].LastProductionStage
            resultvalue.lastUpdatedBy = arr[i].LastUpdatedBy
            resultvalue.lastUpdatedDate = arr[i].LastUpdatedDate
            resultvalue.maintainOperationalCost = arr[i].MaintainOperationalCost
            resultvalue.maximumPrice = arr[i].MaximumPrice
            resultvalue.minimumPrice = arr[i].MinimumPrice
            resultvalue.operationalCostDate = arr[i].OperationalCostDate
            resultvalue.packageUOM = arr[i].PackageUOM
            resultvalue.parentItemNumber = arr[i].ParentItemNumber
            resultvalue.productCategory = arr[i].ProductCategory
            resultvalue.purchaseOrderTolerance = arr[i].PurchaseOrderTolerance
            resultvalue.purchaseUOMDefault = arr[i].PurchaseUOMDefault
            resultvalue.restrictedProduct = arr[i].RestrictedProduct
            resultvalue.sqlID = arr[i].SQLID
            resultvalue.salesOrderTolerance = arr[i].SalesOrderTolerance
            resultvalue.standardRemark1 = arr[i].StandardRemark1;
            resultvalue.standardRemark2 = arr[i].StandardRemark2;
            resultvalue.standardRemark3 = arr[i].StandardRemark3;
            resultvalue.standardRemark4 = arr[i].StandardRemark4;
            resultvalue.standardRemark5 = arr[i].StandardRemark5;
            resultvalue.standardRemark6 = arr[i].StandardRemark6;
            resultvalue.standardRemark7 = arr[i].StandardRemark7;
            resultvalue.standardRemark8 = arr[i].StandardRemark8;
            resultvalue.standardRemark9 = arr[i].StandardRemark9;
            resultvalue.standardRemark10 = arr[i].StandardRemark10;
            resultvalue.stockingUOM = arr[i].StockingUOM;
            resultvalue.stockingUnitsPerPackage = arr[i].StockingUnitsPerPackage;
            resultvalue.taxTable1Default = arr[i].TaxTable1Default;
            resultvalue.taxTable2Default = arr[i].TaxTable2Default;
            resultvalue.taxTable3Default = arr[i].TaxTable3Default;
            resultvalue.tenantID = arr[i].TenantID;
            resultvalue.universalProductCode = arr[i].UniversalProductCode;
            resultvalue.useSubitems = arr[i].UseSubitems;
            resultvalue.varietyCode = arr[i].VarietyCode;
            resultvalue.weightPerStockingUOM = arr[i].WeightPerStockingUOM;
            resultvalue.whereStored = arr[i].WhereStored;
            resultvalue.inventoryBarCodes = arr[i].InventoryBarCodes;
            let itemBalance = new ItemBalance();
            itemBalance.OnHandQuantity = 0;
            itemBalance.PositionQuantity = 0;
            resultvalue.itemBalance = itemBalance;
            itemList.push(resultvalue);
            //   }
            // }
          }
          resolve(itemList);
        }
        //resolve(data);
      }, (error) => {
        reject(error.error);
      }, dataSet.TenantID, `${agentType == 'SQL' ? `TopN|${numberOfItemsInSearchResult}|CrossTenantQuery|true|InventoryItem.OrderBy|Order By <<InventoryItem.Description>> ASC` : `TopN|${numberOfItemsInSearchResult}|InventoryItem.OrderBy|Order By <<InventoryItem.Description>> ASC`}`)
    });

  }
  public getItemDetailsByLocation(itemNumber: string, location: string = utils.getLocation()) {
    let tenantID = this.storage.getTenantID();
    let agentType = localStorage.getItem('AgentType');
    let settings = this.storage.get(StorageKeys.Settings);
    let dataSet = this.storage.get(StorageKeys.DataSet);
    let params = [];

    if (settings.remoteServer == undefined) {
      settings.remoteServer = utils.GetGetwayRemoteDomain();
    }
    agentType == 'SQL' && tenantID ? params.push(`<<InventoryItem.TenantID>> eq '${tenantID}'`) : '';
    itemNumber ? params.push(`<<InventoryItem.Description>> eq '${itemNumber.trim()}' `) : '';
    location ? params.push(`<<InventoryItem.InventoryLocation>> eq '${location.trim()}' `) : '';
    params.push(`<<InventoryItem.Active>> eq 'Y'`);


    // <<InventoryItem.ItemNumber>> startsWith 'GOATFEED' and <<InventoryItem.InventoryLocation>> eq '200'  AND <<InventoryItem.Active>> eq 'Y'

    let url = `/culturahub/RESTActivityWebService/agris.relational/InventoryItem?where=`;
    params.forEach((param, i) => {
      url = `${url}${(i > 0) ? ' and ' : ''}${param}`
    });

    let customerKey = settings.customerKey;
    let SessionID = settings.agentSessionId;

    return new Promise((resolve, reject) => {
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null,
        (data: any) => {
          if (data && data.length)
            resolve(data[0]);
          else
            resolve(null);
        },
        (error: any) => {
          reject(error.error);
        },
        dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true` : ``}`);
    });


  }
  public fetchItemBalanceRelational(itemSearchType: ItemSearchType, request: ItemDetails): Promise<ItemBalance> {
    let onHand = utils.getShowQuantityOfAllLocations();
    if (onHand) return this.fetchItemBalanceForAllLocationsRelational(request);
    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;

      if (agentType == "SQL") {
        url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${dataSet.TenantID}&param1=${settings.locationCode}&param2=${request.itemId}&Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,Location,LocationDV,OnHandQuantity,PositionQuantity`
      }
      else {
        url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${settings.locationCode}&param1=${request.itemId}&Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,Location,LocationDV,OnHandQuantity,PositionQuantity`
      }
      // if (agentType == "SQL") {
      //   url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${dataSet.TenantID}&param1=${settings.locationCode}&param2=${request.itemId}`
      // }
      // else {
      //   url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${settings.locationCode}&param1=${request.itemId}`
      // }

      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {

        // if (itemSearchType == ItemSearchType.Items) {
        let balance: any = {
          ItemNumber: data[0].ItemNumber,
          ItemNumberAndLot: data[0].ItemNumberAndLot,
          Location: data[0].Location,
          LocationDV: data[0].LocationDV,
          OnHandQuantity: 0,
          PositionQuantity: 0
        };
        for (let index = 0; index < data.length; index++) {
          const item = data[index];
          balance.OnHandQuantity += item.OnHandQuantity;
          balance.PositionQuantity += item.PositionQuantity;
        }
        resolve(balance);
        // }else{
        //   resolve(data[0]);
        // }
        // resolve(data[0]);
      }, (error) => {
        reject(error.error);
      },
        // dataSet.TenantID, `${agentType == 'SQL' ? `TopN|${1}|CrossTenantQuery|true` : `TopN|${1}`}`
        dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true` : ``}`
      )
    });
  }
  public fetchItemBalanceByItemNumbersRelational(ItemNumbers: string): Promise<any> {
    let onHand = utils.getShowQuantityOfAllLocations();

    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;


      if (onHand) {

        if (agentType == "SQL") {
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and  <<InventoryBalance.ItemNumber>> IN${ItemNumbers}  &param0=${dataSet.TenantID} &Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,LocationDV,OnHandQuantity,PositionQuantity`
        }
        else {
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.ItemNumber>> IN ${ItemNumbers} &Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,Location,LocationDV,OnHandQuantity,PositionQuantity`
        }

      } else {
        if (agentType == "SQL") {
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> IN${ItemNumbers} and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${dataSet.TenantID}&param1=${settings.locationCode} &Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,Location,LocationDV,OnHandQuantity,PositionQuantity`
        }
        else {
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> IN ${ItemNumbers} and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${settings.locationCode}&Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,Location,LocationDV,OnHandQuantity,PositionQuantity`
        }
      }



      // if (agentType == "SQL") {
      //   url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${dataSet.TenantID}&param1=${settings.locationCode}&param2=${request.itemId}`
      // }
      // else {
      //   url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${settings.locationCode}&param1=${request.itemId}`
      // }

      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {


        if (!data || data.length === 0) {
          reject("No data found");
          return;
        }

        // Creating a map to store aggregated quantities per ItemNumber
        let balanceMap = new Map<string, any>();

        for (let item of data) {
          if (!balanceMap.has(item.ItemNumber)) {
            balanceMap.set(item.ItemNumber, {
              ItemNumber: item.ItemNumber,
              ItemNumberAndLot: item.ItemNumberAndLot,
              Location: item.Location,
              LocationDV: item.LocationDV,
              OnHandQuantity: 0,
              PositionQuantity: 0
            });
          }

          // Aggregate OnHandQuantity and PositionQuantity per ItemNumber
          let balance = balanceMap.get(item.ItemNumber);
          balance.OnHandQuantity += item.OnHandQuantity;
          balance.PositionQuantity += item.PositionQuantity;
        }

        // Convert the map values to an array
        let balanceArray = Array.from(balanceMap.values());

        resolve(balanceArray);
      }, (error) => {
        reject(error.error);
      },
        // dataSet.TenantID, `${agentType == 'SQL' ? `TopN|${1}|CrossTenantQuery|true` : `TopN|${1}`}`
        dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true|TopN|1000` : ``}`
      )
    });
  }


  public fetchItemBalanceForAllLocationsRelational(request: ItemDetails): Promise<ItemBalance> {
    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;
      if (agentType == "SQL") {

        url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${dataSet.TenantID}&param1=${request.itemId}`
      }
      else {

        url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.ItemNumber>> eq ?  &param0=${request.itemId}`

      }
      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }

      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
        let allLocationBalances: ItemBalance[] = data;
        let itemBalance = new ItemBalance();
        itemBalance.OnHandQuantity = 0;
        itemBalance.PositionQuantity = 0;
        allLocationBalances.forEach(b => {
          itemBalance.OnHandQuantity += b.OnHandQuantity;
          itemBalance.PositionQuantity += b.PositionQuantity;
        })
        resolve(itemBalance);
      }, (error) => {
        reject(error.error);
      }, dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true` : ``}`)
    });
  }
  public getItemsByIds(request: ItemRequest, callback, failedcallback) {
    let location = utils.getLocation();
    let tenantID = this.storage.get(StorageKeys.DataSet).TenantID;
    let ids = encodeURIComponent(request.id);
    let onHand = utils.getShowQuantityOfAllLocations();
    this.helper.PostServerCommand(
      `/culturahub/RESTCommandWebService/ExecuteServerCommand/ItemProcessor/GetItemsByIds?TenantID=${tenantID}&SelectedEntities=[InventoryItem:InventoryBarCodes]&ItemLocation=${location}&Onhand=${onHand}&ItemNumbers=${ids}`, null,
      (data) => {
        if (data) {
          let arr = [];
          arr = data;
          let itemList: ItemDetails[] = [];
          console.log(arr);
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].CreatedBy != null) {
              let itemBalance = new ItemBalance();
              itemBalance = JSON.parse(arr[i].CreatedBy)
              if (itemBalance.ItemNumber != null) {
                let resultvalue = new ItemDetails();
                if (onHand) {
                  let allLocationOnHand = JSON.parse(arr[i].LastUpdatedBy);
                  itemBalance.OnHandQuantity = allLocationOnHand && allLocationOnHand.OnHand ? allLocationOnHand.OnHand : 0;
                }
                resultvalue.itemId = arr[i].ItemNumber;
                resultvalue.id = arr[i].ItemNumber;
                resultvalue.itemDescription = arr[i].Description;
                resultvalue.name = arr[i].Description;
                resultvalue.uomschedule = arr[i].SalesUOMDefault;
                resultvalue.uom = arr[i].SalesUOMDefault;
                resultvalue.defaultSellingUom = arr[i].SalesUOMDefault;
                resultvalue.inactive = arr[i].Active;
                resultvalue.branch = arr[i].InventoryLocation;
                resultvalue.category = arr[i].ProductCategory;
                resultvalue.categoryDescription = arr[i].ProductCategoryDV;
                resultvalue.priceLevel1 = arr[i].SellingPrice1;
                resultvalue.priceLevel2 = arr[i].SellingPrice2;
                resultvalue.classCode = arr[i].ClassCode
                resultvalue.commodity = arr[i].Commodity
                resultvalue.costPercent = arr[i].CostPercent
                resultvalue.costProrationMethodDefault = arr[i].CostProrationMethodDefault
                resultvalue.createdBy = "";
                resultvalue.createdDate = arr[i].CreatedDate
                resultvalue.descriptionPartial1of3 = arr[i].DescriptionPartial1of3
                resultvalue.descriptionPartial2of3 = arr[i].DescriptionPartial2of3
                resultvalue.discountTableDefault = arr[i].DiscountTableDefault
                resultvalue.formulaBase = arr[i].FormulaBase
                resultvalue.inventoryItemRemarks = arr[i].InventoryItemRemarks
                resultvalue.inventoryLocation = arr[i].InventoryLocationDV
                resultvalue.inventoryMisc1Code = arr[i].InventoryMisc1Code
                resultvalue.inventoryMisc2Code = arr[i].InventoryMisc2Code
                resultvalue.inventoryMisc3Code = arr[i].InventoryMisc3Code
                resultvalue.inventoryMisc4Code = arr[i].InventoryMisc4Code
                resultvalue.inventoryMisc5Field = arr[i].InventoryMisc5Field
                resultvalue.inventoryMisc6Field = arr[i].InventoryMisc6Field
                resultvalue.inventoryMisc7Field = arr[i].InventoryMisc7Field
                resultvalue.itemOption = arr[i].ItemOption
                resultvalue.itemType = arr[i].ItemType
                resultvalue.lastPhysicalCountDate = arr[i].LastPhysicalCountDate
                resultvalue.lastProductionStage = arr[i].LastProductionStage
                resultvalue.lastUpdatedBy = arr[i].LastUpdatedBy
                resultvalue.lastUpdatedDate = arr[i].LastUpdatedDate
                resultvalue.maintainOperationalCost = arr[i].MaintainOperationalCost
                resultvalue.maximumPrice = arr[i].MaximumPrice
                resultvalue.minimumPrice = arr[i].MinimumPrice
                resultvalue.operationalCostDate = arr[i].OperationalCostDate
                resultvalue.packageUOM = arr[i].PackageUOM
                resultvalue.parentItemNumber = arr[i].ParentItemNumber
                resultvalue.productCategory = arr[i].ProductCategory
                resultvalue.purchaseOrderTolerance = arr[i].PurchaseOrderTolerance
                resultvalue.purchaseUOMDefault = arr[i].PurchaseUOMDefault
                resultvalue.restrictedProduct = arr[i].RestrictedProduct
                resultvalue.sqlID = arr[i].SQLID
                resultvalue.salesOrderTolerance = arr[i].SalesOrderTolerance
                resultvalue.standardRemark1 = arr[i].StandardRemark1;
                resultvalue.standardRemark2 = arr[i].StandardRemark2;
                resultvalue.standardRemark3 = arr[i].StandardRemark3;
                resultvalue.standardRemark4 = arr[i].StandardRemark4;
                resultvalue.standardRemark5 = arr[i].StandardRemark5;
                resultvalue.standardRemark6 = arr[i].StandardRemark6;
                resultvalue.standardRemark7 = arr[i].StandardRemark7;
                resultvalue.standardRemark8 = arr[i].StandardRemark8;
                resultvalue.standardRemark9 = arr[i].StandardRemark9;
                resultvalue.standardRemark10 = arr[i].StandardRemark10;
                resultvalue.stockingUOM = arr[i].StockingUOM;
                resultvalue.stockingUnitsPerPackage = arr[i].StockingUnitsPerPackage;
                resultvalue.taxTable1Default = arr[i].TaxTable1Default;
                resultvalue.taxTable2Default = arr[i].TaxTable2Default;
                resultvalue.taxTable3Default = arr[i].TaxTable3Default;
                resultvalue.tenantID = arr[i].TenantID;
                resultvalue.universalProductCode = arr[i].UniversalProductCode;
                resultvalue.useSubitems = arr[i].UseSubitems;
                resultvalue.varietyCode = arr[i].VarietyCode;
                resultvalue.weightPerStockingUOM = arr[i].WeightPerStockingUOM;
                resultvalue.whereStored = arr[i].WhereStored;
                resultvalue.inventoryBarCodes = arr[i].InventoryBarCodes;
                resultvalue.itemBalance = itemBalance;
                itemList.push(resultvalue);
              }
            }
          }
          callback(itemList);
        }
      }, (error) => {
        failedcallback(error)
      }
    )
  }
  public getSignatureById(bookingId): Promise<any> {

    let promise = new Promise((resolve, reject) => {
      let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/signatureByBookingId/${bookingId}`;
      this.http.get(remoteUrl, {
        headers: {},
      }).pipe(map(data => data)).subscribe(data => {
        resolve(data["TransactionObject"]);
      },
        (error) => {
          reject(error);
        }
      );
    })
    return promise;
  }
  public getOnhandForItemOnLocationFromAgris(itemNumbers, fromBooking = false): Promise<any> {
    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;

      if (agentType == "SQL") {
        if (fromBooking == true)
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.ItemNumber>> eq ? &param0=${dataSet.TenantID}&param1=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity`;
        else
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${dataSet.TenantID}&param1=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity`;
      }
      else {
        if (fromBooking == true)
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.ItemNumber>> eq ? &param0=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity,ItemNumberAndLot`;
        else
          url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity,ItemNumberAndLot`;

      }
      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
        resolve(data);
      }, (error) => {
        reject(error.error);
      }, dataSet.TenantID, 'CrossTenantQuery|true')
    });
  }
  public getOnhandForItemOnLocation(itemNumbers: any, callback) {
    let tenantID = this.storage.get(StorageKeys.DataSet).TenantID;
    this.helper.PostServerCommand(
      "/culturahub/RESTCommandWebService/ExecuteServerCommand/ItemProcessor/InventoryBalanceOnLocationByItemNumber?TenantID=" + tenantID + "&ItemNumbers=" + itemNumbers,
      null,
      (data) => {
        console.log(data);
        if (data.Code == 200) {
          let locations = [];
          let locationOnitems = JSON.parse(data.ResultString);
          for (let a = 0; a < locationOnitems.length; a++) {
            for (let b = 0; b < locationOnitems[a].Locations.length; b++) {
              let location = JSON.parse(locationOnitems[a].Locations[b]);
              let balances = locationOnitems[a].ItemBalanceOnLocations.filter(l => { for (let k in l) { if (k == location.Code) return l; } });
              if (balances.length > 0) {
                let balance = JSON.parse(balances[0][location.Code]);
                location.onHand = balance.OnHandQuantity;
                location.position = balance.PositionQuantity;
                locations.push(location);
              }
            }
          }
          callback({ result: true, locations: locations })
        }
        else {
          callback({ result: false, message: data.ResultString })
        }
      }, (error) => {
        callback({ result: false, message: 'unexpected error occured' })
      });
  }
  public GetProductCategory(productCategoryCode): Promise<any> {
    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;

      if (agentType == "SQL") {
        url = `/culturahub/RESTActivityWebService/agris.relational/ProductCategory?where=<<ProductCategory.TenantID>> eq ? and <<ProductCategory.Code>> eq ?&param0=${dataSet.TenantID}&param1=${productCategoryCode}`
      }
      else {
        url = `/culturahub/RESTActivityWebService/agris.relational/ProductCategory?where=<<ProductCategory.Code>> eq ? &param0=${productCategoryCode}`
      }
      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
        resolve(data);
      }, (error) => {
        reject(error.error);
      }, dataSet.TenantID, 'CrossTenantQuery|true')
    });
  }
  public GetFertilizerItem(itemNumber): Promise<any> {
    return new Promise((resolve, reject) => {
      let url;
      let agentType = localStorage.getItem("AgentType");
      let dataSet = this.storage.get(StorageKeys.DataSet);
      let settings = this.storage.get(StorageKeys.Settings);;

      if (agentType == "SQL") {
        url = `/culturahub/RESTActivityWebService/agris.relational/FertilizerItem?where=<<FertilizerItem.TenantID>> eq ? and <<FertilizerItem.ItemNumber>> eq ?&param0=${dataSet.TenantID}&param1=${itemNumber}`
      }
      else {
        url = `/culturahub/RESTActivityWebService/agris.relational/FertilizerItem?where=<<FertilizerItem.ItemNumber>> eq ? &param0=${itemNumber}`
      }
      let customerKey = settings.customerKey;
      let SessionID = settings.agentSessionId;
      if (settings.remoteServer == undefined) {
        settings.remoteServer = utils.GetGetwayRemoteDomain();
      }
      this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
        resolve(data);
      }, (error) => {
        reject(error.error);
      }, dataSet.TenantID, 'CrossTenantQuery|true')
    });
  }
}


//////// OlD Code

// import { Injectable } from '@angular/core';
// import { ItemDetails } from '../_models/item/item-details.model';
// import { ItemRequest } from '../_models/item/item-request.model';

// import { RequestHelperProvider } from '../../app/_services/request-helper';

// import utils from './../utils';
// import { ItemBalance } from '../_models/item/item-balance.model';
// import { HttpClient } from '@angular/common/http';
// import { map } from 'rxjs/operators';
// import { StorageKeys } from '../_constants';
// import { StorageServiceProvider } from './storage.service';
// import { ItemSearchType } from '../enums';

// import { AuthenticationService } from './authentication.service';

// @Injectable({
//providedIn: 'root'
//})
// export class ItemServiceProvider {

//   constructor(private helper: RequestHelperProvider, private http: HttpClient, private storage: StorageServiceProvider, private authenticationService: AuthenticationService) {
//   }

//   public searchItem(request: ItemRequest, callback, failedcallback) {
//     //this.syncItemsLive(request, callback, failedcallback);
//     let numberOfItemsInSearchResult = utils.getNumberOfItemsInSearchResult();
//     let items;
//     this.syncItemsLiveRelational(request, numberOfItemsInSearchResult).then(data => {
//       if (data.length == numberOfItemsInSearchResult) {
//         callback(data);
//       }
//       else {
//         items = data;
//         this.syncItemsLiveRelational(request, numberOfItemsInSearchResult, 'contains').then(data1 => {
//           items = items.concat(data1);

//           //remove duplicate items
//           items = items.filter((value, index, self) =>
//             index === self.findIndex((t) => (
//               t.place === value.place && t.name === value.name
//             )));

//           //return number of item as per settings
//           let returnItems = [];
//           items.slice([0], [numberOfItemsInSearchResult]).map((item, i) => {
//             returnItems.push(item);
//           });

//           callback(returnItems);
//         }).catch(error => {
//           if (items.length > 0)
//             callback(items);
//           else
//             failedcallback(error);
//         });
//       }
//     }).catch(error => {
//       if (error.Code == 404) {
//         this.syncItemsLiveRelational(request, numberOfItemsInSearchResult, 'contains').then(data1 => {
//           callback(data1);
//         }).catch(error => {
//           failedcallback(error);
//         });
//       } else
//         failedcallback(error);
//     });
//   }

//   public IsPriceOverrideAllowed(): Promise<any> {

//     var response: any = {
//       overrideWithoutWarning: false,
//       overrideWithWarning: false,
//       overrideRestricted: false
//     };
//     return new Promise((resolve, reject) => {
//       this.GetPackageSetupToken("INV", "SO_PRICE_OUTSIDE_MINMAX").then((g) => {
//         if (g != null && g[0].SetupValue == "Y") {

//           response.overrideWithoutWarning = true;
//           resolve(response);
//         }
//         else {

//           let loginid = localStorage.getItem('loginUserId');

//           this.authenticationService.getUserPermissions(loginid, (permissions) => {
//             permissions.forEach(permission => {
//               if (permission.SecurityOption == "OVRMM" && permission.Package == 'INV') {
//                 if (parseInt(permission.SecurityLevel) > 2) {
//                   response.overrideWithWarning = true;
//                 }
//                 else {
//                   response.overrideRestricted = true;
//                 }

//               }
//               else {
//                 response.overrideRestricted = true;
//               }

//             });
//             resolve(response);
//           }, (e) => { reject(e) })
//         }
//       })
//         .catch((err) => {
//           reject(err);
//         })
//     });
//   }
//   public GetPackageSetupToken(packageCode, setupToken): Promise<any> {
//     return new Promise((resolve, reject) => {
//       let url;
//       let agentType = localStorage.getItem("AgentType");
//       let dataSet = this.storage.get(StorageKeys.DataSet);
//       let settings = this.storage.get(StorageKeys.Settings);;

//       if (agentType == "SQL") {
//         url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=<<PackageSetupToken.TenantID>> eq ? and <<PackageSetupToken.PackageCode>> eq ? and <<PackageSetupToken.SetupToken>> eq ? &param0=${dataSet.TenantID}&param1=${packageCode}&param2=${setupToken}`
//       }
//       else {
//         url = `/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=<<PackageSetupToken.PackageCode>> eq ? and <<PackageSetupToken.SetupToken>> eq ? &param0=${packageCode}&param1=${setupToken}`
//       }
//       let customerKey = settings.customerKey;
//       let SessionID = settings.agentSessionId;
//       if (settings.remoteServer == undefined) {
//         settings.remoteServer = utils.GetGetwayRemoteDomain();
//       }
//       this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
//         resolve(data);
//       }, (error) => {
//         reject(error.error);
//       }, dataSet.TenantID, 'CrossTenantQuery|true')
//     });
//   }
//   public getUserPermissionsRelational(packageCode, securityOption): Promise<any> {
//     return new Promise((resolve, reject) => {
//       let url;
//       let agentType = localStorage.getItem("AgentType");
//       let dataSet = this.storage.get(StorageKeys.DataSet);
//       let settings = this.storage.get(StorageKeys.Settings);;

//       if (agentType == "SQL") {
//         url = `/culturahub/RESTActivityWebService/agris.relational/UserMenuSecurityLevel?where=<<UserMenuSecurityLevel.TenantID>> eq ? and <<UserMenuSecurityLevel.Package>> eq ? and <<UserMenuSecurityLevel.SecurityOption>> eq ? &param0=${dataSet.TenantID}&param1=${packageCode}&param2=${securityOption}`
//       }
//       else {
//         url = `/culturahub/RESTActivityWebService/agris.relational/UserMenuSecurityLevel?where=<<UserMenuSecurityLevel.Package>> eq ? and <<UserMenuSecurityLevel.SecurityOption>> eq ? &param0=${packageCode}&param1=${securityOption}`
//       }
//       let customerKey = settings.customerKey;
//       let SessionID = settings.agentSessionId;
//       if (settings.remoteServer == undefined) {
//         settings.remoteServer = utils.GetGetwayRemoteDomain();
//       }
//       this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
//         resolve(data);
//       }, (error) => {
//         reject(error.error);
//       }, dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true` : ``}`)
//     });
//   }
//   //127.0.0.1:8080/agrispsql/RESTCommandWebService/ExecuteServerCommand/ItemProcessor/GetItems?TenantID=133d19ba-aa22-4c1a-8c8a-132757517d8f&SelectedEntities=[InventoryItem:InventoryBarCodes]&InventoryLocation=100&ItemNumber=&Description=&ProductCategory=G1
//   //
//   public syncItemsLive(request: ItemRequest, callback, failedcallback) {
//     let location = utils.getLocation();
//     let numberOfItemsInSearchResult = utils.getNumberOfItemsInSearchResult();
//     let tenantID = this.storage.get(StorageKeys.DataSet).TenantID;
//     let description = encodeURIComponent(request.name);
//     let onHand = utils.getShowQuantityOfAllLocations();
//     this.helper.PostServerCommand(
//       `/culturahub/RESTCommandWebService/ExecuteServerCommand/ItemProcessor/GetItems?TenantID=${tenantID}&SelectedEntities=[InventoryItem:InventoryBarCodes]&InventoryLocation=${location}&ItemNumber=${request.id}&Description=${description}&ProductCategory=${request.categoryDescription}&TopN=${numberOfItemsInSearchResult}&Onhand=${onHand}`, null,
//       (data) => {
//         if (data) {
//           let arr = [];
//           //  arr = (data.Items.map(d => { let obj = d; delete obj._Entity; return obj }));
//           arr = data;
//           let itemList: ItemDetails[] = [];
//           console.log(arr);
//           for (var i = 0; i < arr.length; i++) {
//             if (arr[i].CreatedBy != null) {
//               let itemBalance = new ItemBalance();
//               itemBalance = JSON.parse(arr[i].CreatedBy)
//               if (itemBalance.ItemNumber != null) {
//                 let resultvalue = new ItemDetails();
//                 if (onHand && arr[i].LastUpdatedBy) {
//                   let allLocationOnHand = JSON.parse(arr[i].LastUpdatedBy);
//                   itemBalance.OnHandQuantity = allLocationOnHand.OnHand ? allLocationOnHand.OnHand : 0;
//                 }
//                 resultvalue.itemId = arr[i].ItemNumber;
//                 resultvalue.id = arr[i].ItemNumber;
//                 resultvalue.itemDescription = arr[i].Description;
//                 resultvalue.name = arr[i].Description;
//                 resultvalue.uomschedule = arr[i].SalesUOMDefault;
//                 resultvalue.uom = arr[i].SalesUOMDefault;
//                 resultvalue.defaultSellingUom = arr[i].SalesUOMDefault;
//                 resultvalue.inactive = arr[i].Active;
//                 resultvalue.branch = arr[i].InventoryLocation;
//                 resultvalue.category = arr[i].ProductCategory;
//                 resultvalue.categoryDescription = arr[i].ProductCategoryDV;
//                 resultvalue.priceLevel1 = arr[i].SellingPrice1;
//                 resultvalue.priceLevel2 = arr[i].SellingPrice2;
//                 resultvalue.classCode = arr[i].ClassCode
//                 resultvalue.commodity = arr[i].Commodity
//                 resultvalue.costPercent = arr[i].CostPercent
//                 resultvalue.costProrationMethodDefault = arr[i].CostProrationMethodDefault
//                 resultvalue.createdBy = "";
//                 resultvalue.createdDate = arr[i].CreatedDate
//                 resultvalue.descriptionPartial1of3 = arr[i].DescriptionPartial1of3
//                 resultvalue.descriptionPartial2of3 = arr[i].DescriptionPartial2of3
//                 resultvalue.discountTableDefault = arr[i].DiscountTableDefault
//                 resultvalue.formulaBase = arr[i].FormulaBase
//                 resultvalue.inventoryItemRemarks = arr[i].InventoryItemRemarks
//                 resultvalue.inventoryLocation = arr[i].InventoryLocationDV
//                 resultvalue.inventoryMisc1Code = arr[i].InventoryMisc1Code
//                 resultvalue.inventoryMisc2Code = arr[i].InventoryMisc2Code
//                 resultvalue.inventoryMisc3Code = arr[i].InventoryMisc3Code
//                 resultvalue.inventoryMisc4Code = arr[i].InventoryMisc4Code
//                 resultvalue.inventoryMisc5Field = arr[i].InventoryMisc5Field
//                 resultvalue.inventoryMisc6Field = arr[i].InventoryMisc6Field
//                 resultvalue.inventoryMisc7Field = arr[i].InventoryMisc7Field
//                 resultvalue.itemOption = arr[i].ItemOption
//                 resultvalue.itemType = arr[i].ItemType
//                 resultvalue.lastPhysicalCountDate = arr[i].LastPhysicalCountDate
//                 resultvalue.lastProductionStage = arr[i].LastProductionStage
//                 resultvalue.lastUpdatedBy = arr[i].LastUpdatedBy
//                 resultvalue.lastUpdatedDate = arr[i].LastUpdatedDate
//                 resultvalue.maintainOperationalCost = arr[i].MaintainOperationalCost
//                 resultvalue.maximumPrice = arr[i].MaximumPrice
//                 resultvalue.minimumPrice = arr[i].MinimumPrice
//                 resultvalue.operationalCostDate = arr[i].OperationalCostDate
//                 resultvalue.packageUOM = arr[i].PackageUOM
//                 resultvalue.parentItemNumber = arr[i].ParentItemNumber
//                 resultvalue.productCategory = arr[i].ProductCategory
//                 resultvalue.purchaseOrderTolerance = arr[i].PurchaseOrderTolerance
//                 resultvalue.purchaseUOMDefault = arr[i].PurchaseUOMDefault
//                 resultvalue.restrictedProduct = arr[i].RestrictedProduct
//                 resultvalue.sqlID = arr[i].SQLID
//                 resultvalue.salesOrderTolerance = arr[i].SalesOrderTolerance
//                 resultvalue.standardRemark1 = arr[i].StandardRemark1;
//                 resultvalue.standardRemark2 = arr[i].StandardRemark2;
//                 resultvalue.standardRemark3 = arr[i].StandardRemark3;
//                 resultvalue.standardRemark4 = arr[i].StandardRemark4;
//                 resultvalue.standardRemark5 = arr[i].StandardRemark5;
//                 resultvalue.standardRemark6 = arr[i].StandardRemark6;
//                 resultvalue.standardRemark7 = arr[i].StandardRemark7;
//                 resultvalue.standardRemark8 = arr[i].StandardRemark8;
//                 resultvalue.standardRemark9 = arr[i].StandardRemark9;
//                 resultvalue.standardRemark10 = arr[i].StandardRemark10;
//                 resultvalue.stockingUOM = arr[i].StockingUOM;
//                 resultvalue.stockingUnitsPerPackage = arr[i].StockingUnitsPerPackage;
//                 resultvalue.taxTable1Default = arr[i].TaxTable1Default;
//                 resultvalue.taxTable2Default = arr[i].TaxTable2Default;
//                 resultvalue.taxTable3Default = arr[i].TaxTable3Default;
//                 resultvalue.tenantID = arr[i].TenantID;
//                 resultvalue.universalProductCode = arr[i].UniversalProductCode;
//                 resultvalue.useSubitems = arr[i].UseSubitems;
//                 resultvalue.varietyCode = arr[i].VarietyCode;
//                 resultvalue.weightPerStockingUOM = arr[i].WeightPerStockingUOM;
//                 resultvalue.whereStored = arr[i].WhereStored;
//                 resultvalue.inventoryBarCodes = arr[i].InventoryBarCodes;
//                 resultvalue.itemBalance = itemBalance;
//                 itemList.push(resultvalue);
//               }
//             }
//           }
//           callback(itemList);
//         }
//       }, (error) => {
//         failedcallback(error)
//       }
//     )
//   }

//   public syncItemsLiveRelational(request: ItemRequest, numberOfItemsInSearchResult, descriptionSearchFilter: string = 'startsWith'): Promise<any> {
//     return new Promise((resolve, reject) => {
//       let location = utils.getLocation();
//       let tenantID = this.storage.getTenantID();
//       let description = encodeURIComponent(request.name);
//       let onHand = utils.getShowQuantityOfAllLocations();
//       let params = [];
//       let agentType = localStorage.getItem('AgentType');
//       let settings = this.storage.get(StorageKeys.Settings);
//       let dataSet = this.storage.get(StorageKeys.DataSet);
//       agentType == 'SQL' && tenantID ? params.push(`<<InventoryItem.TenantID>> eq '${tenantID}'`) : '';
//       request.id ? params.push(`<<InventoryItem.ItemNumber>> contains '${request.id.trim()}'`) : '';
//       request.name ? params.push(`<<InventoryItem.Description>> ${descriptionSearchFilter} '${request.name.trim()}'`) : '';
//       request.categoryDescription ? params.push(`<<InventoryItem.ProductCategory>> contains '${request.categoryDescription.trim()}'`) : '';
//       location ? params.push(`<<InventoryItem.InventoryLocation>> eq '${location}'  AND <<InventoryItem.Active>> eq 'Y'`) : '';
//       let customerKey = settings.customerKey;
//       let SessionID = settings.agentSessionId;
//       if (settings.remoteServer == undefined) {
//         settings.remoteServer = utils.GetGetwayRemoteDomain();
//       }
//       let url = `/culturahub/RESTActivityWebService/agris.relational/InventoryItem?where=`;
//       params.forEach((param, i) => {
//         url = `${url}${(i > 0) ? ' and ' : ''}${param}`
//       });
//       let ORParams = [];
//       request.itemBarCode ? params.push(`<<InventoryItem.InventoryBarCodes>> AND <<InventoryBarCodes.BarCode>> contains '${request.itemBarCode}'`) : '';
//       ORParams.forEach((param, i) => {
//         url = `${url}${(i > 0) ? ' OR ' : ''}${param}`
//       });
//       this.helper.Get(settings.remoteServer + url, customerKey, SessionID, '[InventoryItem:InventoryBarCodes]', (data) => {
//         if (data) {
//           let arr = [];
//           //  arr = (data.Items.map(d => { let obj = d; delete obj._Entity; return obj }));
//           arr = data;
//           let itemList: ItemDetails[] = [];
//           console.log(arr);
//           for (var i = 0; i < arr.length; i++) {

//             // if (arr[i].CreatedBy != null && this.utilities.isValidJSON(arr[i].CreatedBy)) {
//             //   let itemBalance = new ItemBalance();
//             //   itemBalance = JSON.parse(arr[i].CreatedBy)
//             //   if (itemBalance.ItemNumber != null) {
//             let resultvalue = new ItemDetails();
//             resultvalue.id = arr[i].ItemNumber;
//             resultvalue.itemId = arr[i].ItemNumber;
//             resultvalue.itemDescription = arr[i].Description;
//             resultvalue.name = arr[i].Description;
//             resultvalue.uomschedule = arr[i].SalesUOMDefault;
//             resultvalue.uom = arr[i].SalesUOMDefault;
//             resultvalue.defaultSellingUom = arr[i].SalesUOMDefault;
//             resultvalue.inactive = arr[i].Active;
//             resultvalue.branch = arr[i].InventoryLocation;
//             resultvalue.category = arr[i].ProductCategory;
//             resultvalue.categoryDescription = arr[i].ProductCategoryDV;
//             resultvalue.price = arr[i].SellingPrice1;
//             resultvalue.priceLevel1 = arr[i].SellingPrice1;
//             resultvalue.priceLevel2 = arr[i].SellingPrice2;
//             resultvalue.classCode = arr[i].ClassCode
//             resultvalue.commodity = arr[i].Commodity
//             resultvalue.costPercent = arr[i].CostPercent
//             resultvalue.costProrationMethodDefault = arr[i].CostProrationMethodDefault
//             resultvalue.createdBy = "";
//             resultvalue.createdDate = arr[i].CreatedDate
//             resultvalue.descriptionPartial1of3 = arr[i].DescriptionPartial1of3
//             resultvalue.descriptionPartial2of3 = arr[i].DescriptionPartial2of3
//             resultvalue.discountTableDefault = arr[i].DiscountTableDefault
//             resultvalue.formulaBase = arr[i].FormulaBase
//             resultvalue.inventoryItemRemarks = arr[i].InventoryItemRemarks
//             resultvalue.inventoryLocation = arr[i].InventoryLocationDV
//             resultvalue.inventoryMisc1Code = arr[i].InventoryMisc1Code
//             resultvalue.inventoryMisc2Code = arr[i].InventoryMisc2Code
//             resultvalue.inventoryMisc3Code = arr[i].InventoryMisc3Code
//             resultvalue.inventoryMisc4Code = arr[i].InventoryMisc4Code
//             resultvalue.inventoryMisc5Field = arr[i].InventoryMisc5Field
//             resultvalue.inventoryMisc6Field = arr[i].InventoryMisc6Field
//             resultvalue.inventoryMisc7Field = arr[i].InventoryMisc7Field
//             resultvalue.itemOption = arr[i].ItemOption
//             resultvalue.itemType = arr[i].ItemType
//             resultvalue.lastPhysicalCountDate = arr[i].LastPhysicalCountDate
//             resultvalue.lastProductionStage = arr[i].LastProductionStage
//             resultvalue.lastUpdatedBy = arr[i].LastUpdatedBy
//             resultvalue.lastUpdatedDate = arr[i].LastUpdatedDate
//             resultvalue.maintainOperationalCost = arr[i].MaintainOperationalCost
//             resultvalue.maximumPrice = arr[i].MaximumPrice
//             resultvalue.minimumPrice = arr[i].MinimumPrice
//             resultvalue.operationalCostDate = arr[i].OperationalCostDate
//             resultvalue.packageUOM = arr[i].PackageUOM
//             resultvalue.parentItemNumber = arr[i].ParentItemNumber
//             resultvalue.productCategory = arr[i].ProductCategory
//             resultvalue.purchaseOrderTolerance = arr[i].PurchaseOrderTolerance
//             resultvalue.purchaseUOMDefault = arr[i].PurchaseUOMDefault
//             resultvalue.restrictedProduct = arr[i].RestrictedProduct
//             resultvalue.sqlID = arr[i].SQLID
//             resultvalue.salesOrderTolerance = arr[i].SalesOrderTolerance
//             resultvalue.standardRemark1 = arr[i].StandardRemark1;
//             resultvalue.standardRemark2 = arr[i].StandardRemark2;
//             resultvalue.standardRemark3 = arr[i].StandardRemark3;
//             resultvalue.standardRemark4 = arr[i].StandardRemark4;
//             resultvalue.standardRemark5 = arr[i].StandardRemark5;
//             resultvalue.standardRemark6 = arr[i].StandardRemark6;
//             resultvalue.standardRemark7 = arr[i].StandardRemark7;
//             resultvalue.standardRemark8 = arr[i].StandardRemark8;
//             resultvalue.standardRemark9 = arr[i].StandardRemark9;
//             resultvalue.standardRemark10 = arr[i].StandardRemark10;
//             resultvalue.stockingUOM = arr[i].StockingUOM;
//             resultvalue.stockingUnitsPerPackage = arr[i].StockingUnitsPerPackage;
//             resultvalue.taxTable1Default = arr[i].TaxTable1Default;
//             resultvalue.taxTable2Default = arr[i].TaxTable2Default;
//             resultvalue.taxTable3Default = arr[i].TaxTable3Default;
//             resultvalue.tenantID = arr[i].TenantID;
//             resultvalue.universalProductCode = arr[i].UniversalProductCode;
//             resultvalue.useSubitems = arr[i].UseSubitems;
//             resultvalue.varietyCode = arr[i].VarietyCode;
//             resultvalue.weightPerStockingUOM = arr[i].WeightPerStockingUOM;
//             resultvalue.whereStored = arr[i].WhereStored;
//             resultvalue.inventoryBarCodes = arr[i].InventoryBarCodes;
//             let itemBalance = new ItemBalance();
//             itemBalance.OnHandQuantity = 0;
//             itemBalance.PositionQuantity = 0;
//             resultvalue.itemBalance = itemBalance;
//             itemList.push(resultvalue);
//             //   }
//             // }
//           }
//           resolve(itemList);
//         }
//         //resolve(data);
//       }, (error) => {
//         reject(error.error);
//       }, dataSet.TenantID, `${agentType == 'SQL' ? `TopN|${numberOfItemsInSearchResult}|CrossTenantQuery|true|InventoryItem.OrderBy|Order By <<InventoryItem.Description>> ASC` : `TopN|${numberOfItemsInSearchResult}|InventoryItem.OrderBy|Order By <<InventoryItem.Description>> ASC`}`)
//     });

//   }

//   public fetchItemBalanceRelational(itemSearchType: ItemSearchType, request: ItemDetails): Promise<ItemBalance> {
//     let onHand = utils.getShowQuantityOfAllLocations();
//     if (onHand) return this.fetchItemBalanceForAllLocationsRelational(request);
//     return new Promise((resolve, reject) => {
//       let url;
//       let agentType = localStorage.getItem("AgentType");
//       let dataSet = this.storage.get(StorageKeys.DataSet);
//       let settings = this.storage.get(StorageKeys.Settings);;

//       if (agentType == "SQL") {
//         url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${dataSet.TenantID}&param1=${settings.locationCode}&param2=${request.itemId}&Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,Location,LocationDV,OnHandQuantity,PositionQuantity`
//       }
//       else {
//         url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${settings.locationCode}&param1=${request.itemId}&Properties=InventoryBalance:ItemDescription,ItemNumber,ItemNumberAndLot,Location,LocationDV,OnHandQuantity,PositionQuantity`
//       }
//       // if (agentType == "SQL") {
//       //   url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${dataSet.TenantID}&param1=${settings.locationCode}&param2=${request.itemId}`
//       // }
//       // else {
//       //   url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.Location>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${settings.locationCode}&param1=${request.itemId}`
//       // }

//       let customerKey = settings.customerKey;
//       let SessionID = settings.agentSessionId;
//       if (settings.remoteServer == undefined) {
//         settings.remoteServer = utils.GetGetwayRemoteDomain();
//       }
//       this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {

//         // if (itemSearchType == ItemSearchType.Items) {
//         let balance: any = {
//           ItemNumber: data[0].ItemNumber,
//           ItemNumberAndLot: data[0].ItemNumberAndLot,
//           Location: data[0].Location,
//           LocationDV: data[0].LocationDV,
//           OnHandQuantity: 0,
//           PositionQuantity: 0
//         };
//         for (let index = 0; index < data.length; index++) {
//           const item = data[index];
//           balance.OnHandQuantity += item.OnHandQuantity;
//           balance.PositionQuantity += item.PositionQuantity;
//         }
//         resolve(balance);
//         // }else{
//         //   resolve(data[0]);
//         // }
//         // resolve(data[0]);
//       }, (error) => {
//         reject(error.error);
//       },
//         // dataSet.TenantID, `${agentType == 'SQL' ? `TopN|${1}|CrossTenantQuery|true` : `TopN|${1}`}`
//         dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true` : ``}`
//       )
//     });
//   }
//   public fetchItemBalanceForAllLocationsRelational(request: ItemDetails): Promise<ItemBalance> {
//     return new Promise((resolve, reject) => {
//       let url;
//       let agentType = localStorage.getItem("AgentType");
//       let dataSet = this.storage.get(StorageKeys.DataSet);
//       let settings = this.storage.get(StorageKeys.Settings);;
//       if (agentType == "SQL") {

//         url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.ItemNumber>> eq ?  &param0=${dataSet.TenantID}&param1=${request.itemId}`
//       }
//       else {

//         url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.ItemNumber>> eq ?  &param0=${request.itemId}`

//       }
//       let customerKey = settings.customerKey;
//       let SessionID = settings.agentSessionId;
//       if (settings.remoteServer == undefined) {
//         settings.remoteServer = utils.GetGetwayRemoteDomain();
//       }
//       this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
//         let allLocationBalances: ItemBalance[] = data;
//         let itemBalance = new ItemBalance();
//         itemBalance.OnHandQuantity = 0;
//         itemBalance.PositionQuantity = 0;
//         allLocationBalances.forEach(b => {
//           itemBalance.OnHandQuantity += b.OnHandQuantity;
//           itemBalance.PositionQuantity += b.PositionQuantity;
//         })
//         resolve(itemBalance);
//       }, (error) => {
//         reject(error.error);
//       }, dataSet.TenantID, `${agentType == 'SQL' ? `CrossTenantQuery|true|` : ``}`)
//     });
//   }

//   //   }, e => {
//   //     if (e && e.error && e.error.Code == 404) {
//   //       resolve([]);
//   //     } else {
//   //     console.log(e);
//   //     reject(e);
//   //     }
//   //   }, tenantID, `${agentType == 'SQL' ? `TopN|${numberOfItemsInSearchResult}|CrossTenantQuery|true|InventoryItem.OrderBy|Order By <<InventoryItem.Description>> ASC` : `InventoryItem.OrderBy|Order By <<InventoryItem.Description>> ASC`}`);
//   // });
//   // }

//   public getItemsByIds(request: ItemRequest, callback, failedcallback) {
//     let location = utils.getLocation();
//     let tenantID = this.storage.get(StorageKeys.DataSet).TenantID;
//     let ids = encodeURIComponent(request.id);
//     let onHand = utils.getShowQuantityOfAllLocations();
//     this.helper.PostServerCommand(
//       `/culturahub/RESTCommandWebService/ExecuteServerCommand/ItemProcessor/GetItemsByIds?TenantID=${tenantID}&SelectedEntities=[InventoryItem:InventoryBarCodes]&ItemLocation=${location}&Onhand=${onHand}&ItemNumbers=${ids}`, null,
//       (data) => {
//         if (data) {
//           let arr = [];
//           arr = data;
//           let itemList: ItemDetails[] = [];
//           console.log(arr);
//           for (var i = 0; i < arr.length; i++) {
//             if (arr[i].CreatedBy != null) {
//               let itemBalance = new ItemBalance();
//               itemBalance = JSON.parse(arr[i].CreatedBy)
//               if (itemBalance.ItemNumber != null) {
//                 let resultvalue = new ItemDetails();
//                 if (onHand) {
//                   let allLocationOnHand = JSON.parse(arr[i].LastUpdatedBy);
//                   itemBalance.OnHandQuantity = allLocationOnHand && allLocationOnHand.OnHand ? allLocationOnHand.OnHand : 0;
//                 }
//                 resultvalue.itemId = arr[i].ItemNumber;
//                 resultvalue.id = arr[i].ItemNumber;
//                 resultvalue.itemDescription = arr[i].Description;
//                 resultvalue.name = arr[i].Description;
//                 resultvalue.uomschedule = arr[i].SalesUOMDefault;
//                 resultvalue.uom = arr[i].SalesUOMDefault;
//                 resultvalue.defaultSellingUom = arr[i].SalesUOMDefault;
//                 resultvalue.inactive = arr[i].Active;
//                 resultvalue.branch = arr[i].InventoryLocation;
//                 resultvalue.category = arr[i].ProductCategory;
//                 resultvalue.categoryDescription = arr[i].ProductCategoryDV;
//                 resultvalue.priceLevel1 = arr[i].SellingPrice1;
//                 resultvalue.priceLevel2 = arr[i].SellingPrice2;
//                 resultvalue.classCode = arr[i].ClassCode
//                 resultvalue.commodity = arr[i].Commodity
//                 resultvalue.costPercent = arr[i].CostPercent
//                 resultvalue.costProrationMethodDefault = arr[i].CostProrationMethodDefault
//                 resultvalue.createdBy = "";
//                 resultvalue.createdDate = arr[i].CreatedDate
//                 resultvalue.descriptionPartial1of3 = arr[i].DescriptionPartial1of3
//                 resultvalue.descriptionPartial2of3 = arr[i].DescriptionPartial2of3
//                 resultvalue.discountTableDefault = arr[i].DiscountTableDefault
//                 resultvalue.formulaBase = arr[i].FormulaBase
//                 resultvalue.inventoryItemRemarks = arr[i].InventoryItemRemarks
//                 resultvalue.inventoryLocation = arr[i].InventoryLocationDV
//                 resultvalue.inventoryMisc1Code = arr[i].InventoryMisc1Code
//                 resultvalue.inventoryMisc2Code = arr[i].InventoryMisc2Code
//                 resultvalue.inventoryMisc3Code = arr[i].InventoryMisc3Code
//                 resultvalue.inventoryMisc4Code = arr[i].InventoryMisc4Code
//                 resultvalue.inventoryMisc5Field = arr[i].InventoryMisc5Field
//                 resultvalue.inventoryMisc6Field = arr[i].InventoryMisc6Field
//                 resultvalue.inventoryMisc7Field = arr[i].InventoryMisc7Field
//                 resultvalue.itemOption = arr[i].ItemOption
//                 resultvalue.itemType = arr[i].ItemType
//                 resultvalue.lastPhysicalCountDate = arr[i].LastPhysicalCountDate
//                 resultvalue.lastProductionStage = arr[i].LastProductionStage
//                 resultvalue.lastUpdatedBy = arr[i].LastUpdatedBy
//                 resultvalue.lastUpdatedDate = arr[i].LastUpdatedDate
//                 resultvalue.maintainOperationalCost = arr[i].MaintainOperationalCost
//                 resultvalue.maximumPrice = arr[i].MaximumPrice
//                 resultvalue.minimumPrice = arr[i].MinimumPrice
//                 resultvalue.operationalCostDate = arr[i].OperationalCostDate
//                 resultvalue.packageUOM = arr[i].PackageUOM
//                 resultvalue.parentItemNumber = arr[i].ParentItemNumber
//                 resultvalue.productCategory = arr[i].ProductCategory
//                 resultvalue.purchaseOrderTolerance = arr[i].PurchaseOrderTolerance
//                 resultvalue.purchaseUOMDefault = arr[i].PurchaseUOMDefault
//                 resultvalue.restrictedProduct = arr[i].RestrictedProduct
//                 resultvalue.sqlID = arr[i].SQLID
//                 resultvalue.salesOrderTolerance = arr[i].SalesOrderTolerance
//                 resultvalue.standardRemark1 = arr[i].StandardRemark1;
//                 resultvalue.standardRemark2 = arr[i].StandardRemark2;
//                 resultvalue.standardRemark3 = arr[i].StandardRemark3;
//                 resultvalue.standardRemark4 = arr[i].StandardRemark4;
//                 resultvalue.standardRemark5 = arr[i].StandardRemark5;
//                 resultvalue.standardRemark6 = arr[i].StandardRemark6;
//                 resultvalue.standardRemark7 = arr[i].StandardRemark7;
//                 resultvalue.standardRemark8 = arr[i].StandardRemark8;
//                 resultvalue.standardRemark9 = arr[i].StandardRemark9;
//                 resultvalue.standardRemark10 = arr[i].StandardRemark10;
//                 resultvalue.stockingUOM = arr[i].StockingUOM;
//                 resultvalue.stockingUnitsPerPackage = arr[i].StockingUnitsPerPackage;
//                 resultvalue.taxTable1Default = arr[i].TaxTable1Default;
//                 resultvalue.taxTable2Default = arr[i].TaxTable2Default;
//                 resultvalue.taxTable3Default = arr[i].TaxTable3Default;
//                 resultvalue.tenantID = arr[i].TenantID;
//                 resultvalue.universalProductCode = arr[i].UniversalProductCode;
//                 resultvalue.useSubitems = arr[i].UseSubitems;
//                 resultvalue.varietyCode = arr[i].VarietyCode;
//                 resultvalue.weightPerStockingUOM = arr[i].WeightPerStockingUOM;
//                 resultvalue.whereStored = arr[i].WhereStored;
//                 resultvalue.inventoryBarCodes = arr[i].InventoryBarCodes;
//                 resultvalue.itemBalance = itemBalance;
//                 itemList.push(resultvalue);
//               }
//             }
//           }
//           callback(itemList);
//         }
//       }, (error) => {
//         failedcallback(error)
//       }
//     )
//   }
//   public getSignatureById(bookingId): Promise<any> {

//     let promise = new Promise((resolve, reject) => {
//       let remoteUrl = `${utils.GetSalesReviewRemoteServer()}/Bookings/signatureByBookingId/${bookingId}`;
//       this.http.get(remoteUrl, {
//         headers: {},
//       }).pipe(map(data => data)).subscribe(data => {
//         resolve(data["TransactionObject"]);
//       },
//         (error) => {
//           reject(error);
//         }
//       );
//     })
//     return promise;
//   }


//   public getOnhandForItemOnLocationFromAgris(itemNumbers): Promise<any> {
//     return new Promise((resolve, reject) => {
//       let url;
//       let agentType = localStorage.getItem("AgentType");
//       let dataSet = this.storage.get(StorageKeys.DataSet);
//       let settings = this.storage.get(StorageKeys.Settings);;

//       if (agentType == "SQL") {
//         url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${dataSet.TenantID}&param1=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity`
//         // url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.TenantID>> eq ? and <<InventoryBalance.ItemNumberAndLot>> eq ? &param0=${dataSet.TenantID}&param1=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity`


//       }
//       else {
//         url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.ItemNumber>> eq ? and <<InventoryBalance.OnHandQuantity>> <> 0 &param0=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity,ItemNumberAndLot`
//         // url = `/culturahub/RESTActivityWebService/agris.relational/InventoryBalance?where=<<InventoryBalance.ItemNumberAndLot>> eq ? &param0=${itemNumbers}&Properties=InventoryBalance:ItemNumber,Location,LocationDV,OnHandQuantity,PositionQuantity,ItemNumberAndLot`

//       }
//       let customerKey = settings.customerKey;
//       let SessionID = settings.agentSessionId;
//       if (settings.remoteServer == undefined) {
//         settings.remoteServer = utils.GetGetwayRemoteDomain();
//       }
//       this.helper.Get(settings.remoteServer + url, customerKey, SessionID, null, (data) => {
//         resolve(data);
//       }, (error) => {
//         reject(error.error);
//       }, dataSet.TenantID, 'CrossTenantQuery|true')
//     });
//   }
//   public getOnhandForItemOnLocation(itemNumbers: any, callback) {
//     let tenantID = this.storage.get(StorageKeys.DataSet).TenantID;
//     this.helper.PostServerCommand(
//       "/culturahub/RESTCommandWebService/ExecuteServerCommand/ItemProcessor/InventoryBalanceOnLocationByItemNumber?TenantID=" + tenantID + "&ItemNumbers=" + itemNumbers,
//       null,
//       (data) => {
//         console.log(data);
//         if (data.Code == 200) {
//           let locations = [];
//           let locationOnitems = JSON.parse(data.ResultString);
//           for (let a = 0; a < locationOnitems.length; a++) {
//             for (let b = 0; b < locationOnitems[a].Locations.length; b++) {
//               let location = JSON.parse(locationOnitems[a].Locations[b]);
//               let balances = locationOnitems[a].ItemBalanceOnLocations.filter(l => { for (let k in l) { if (k == location.Code) return l; } });
//               if (balances.length > 0) {
//                 let balance = JSON.parse(balances[0][location.Code]);
//                 location.onHand = balance.OnHandQuantity;
//                 location.position = balance.PositionQuantity;
//                 locations.push(location);
//               }
//             }
//           }
//           callback({ result: true, locations: locations })
//         }
//         else {
//           callback({ result: false, message: data.ResultString })
//         }
//       }, (error) => {
//         callback({ result: false, message: 'unexpected error occured' })
//       });
//   }
// }
